import { SecondaryListingEntry } from "kreate-common/modules/business-types";
import { safeParseKreateUtxoOffer } from "kreate-common/modules/utxo-parser/by-type/offer";
import Link from "next/link";

import {
  formatAddress$Compact,
  formatAddress$Standard,
} from "@/modules/common-utils/format";
import { getLinkToPageGalleryCollector } from "@/modules/navigation/utils/getLinkTo";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  entry: SecondaryListingEntry;
  unstyled: true;
};

export function OffererNameViewer({ className, style, entry }: Props) {
  const firstAddress = entry.populated?.galleryCollector?.addresses[0].address;
  const parsedUtxo = safeParseKreateUtxoOffer(entry.utxo).result;
  const displayName =
    entry.populated?.galleryCollector?.populated?.galleryInfo?.title ??
    entry.populated?.galleryCollector?.populated?.userProfile?.displayName;
  return (
    <Link
      className={className}
      style={style}
      href={
        firstAddress ? getLinkToPageGalleryCollector(firstAddress) : "#disabled"
      }
      title={
        !displayName
          ? formatAddress$Standard(parsedUtxo?.datumOffer.offererAddress)
          : undefined
      }
    >
      {displayName ||
        formatAddress$Compact(parsedUtxo?.datumOffer.offererAddress)}
    </Link>
  );
}
